/* globals ga */
(function() {

  'use strict';

  function GastoMensalCtrl ($scope, $state, $window, FinalizaCadastro, Perfil) {

    var vm = this;
    vm.showLoading = false;
    var user = Perfil.getCacheUserData();

    vm.documento = {};
    if (user) {
      vm.gastoMensalSelecionado = user.gastoMensalComFrete;
    }

    vm.salvarGastoMensal = function (form) {
      if (!form.$valid) { return; }
      vm.showLoading = true;

      FinalizaCadastro.gravaGastoMensal({ 'gastoMensal': vm.gastoMensalSelecionado })
        .then(function() {
          vm.showLoading = false;
          // parametro true ignora o cache
          Perfil.getUserData(true)
            .then(function(user) {
              // vai para proxima tela
              $state.go('endereco', { user: user });
            })
            .catch(function(err) {
              console.log(err);
            });
        }).catch(function() {
          vm.showLoading = false;
          // $scope.tratarErrosBackEnd(error);
        });
    };
  }

  angular
    .module('mandaeApp')
    .controller('GastoMensalCtrl', GastoMensalCtrl);

}());
